module.exports = require('./helpers/bundle-url').getBundleURL('9rAa3') + "apple-logo.54e0d711.svg";